// Suppress disruptive alerts from WebFeatureAppService web fallbacks
// This must be called before calling any WebFeatureAppService methods
export const suppressWebFeatureAlerts = () => {
    const originalAlert = window.alert;
    window.alert = (message: any) => {
        // Suppress loading state alerts from WebFeatureAppService
        if (typeof message === 'string' && message.includes('Web fallback for "App.loading()"')) {
            return;
        }
        // Allow other alerts to pass through
        originalAlert(message);
    };
};

// Call immediately when this module loads
suppressWebFeatureAlerts();
